export default __webpack_public_path__ + "static/CooperBT-Light-699360ad3703ca19de21fcef6bd8e567.woff";